export const EFFECTIVE_PRICE_CHANGED_TOPIC = 'ft5.variation.price.change';

export type EffectivePriceChangeEvent = {
    variationId: string;
    newPriceCents: number;
};

export function getRenderedEffectivePrice(): EffectivePriceChangeEvent | undefined {
    const priceRoot = document.querySelector<HTMLElement>('.js_pdp_price');
    const priceElement = priceRoot?.querySelector<HTMLElement>('.js_pdp_price__tag:not(.pl_hidden)');
    const serializedPrice = priceElement?.dataset.priceCents;

    if (!priceRoot || serializedPrice === undefined || serializedPrice === '') {
        return undefined;
    }

    const newPriceCents = Number(serializedPrice);
    if (!Number.isFinite(newPriceCents)) {
        return undefined;
    }

    return {
        variationId: priceRoot.dataset.variationId || '',
        newPriceCents,
    };
}
